import inventoryTransferApi from "../../../api/inventory/inventoryTransferApi";
import {
  InventoryTransferCreateDTO,
  InventoryTransferUpdateDTO,
} from "../../../types/inventory/transfer/InventoryTransferTypes";

const InventoryTransferService = {
  /**
   * ➕ Crear traslado
   * POST /api/inventory/transfers
   */
  create: async (payload: InventoryTransferCreateDTO) => {
    const response = await inventoryTransferApi.add(payload);
    return response.data;
  },

  /**
   * ✏️ Actualizar traslado
   * PUT /api/inventory/transfers/{id}
   */
  update: async (id: number, payload: InventoryTransferUpdateDTO) => {
    const response = await inventoryTransferApi.modifyCustom(`/${id}`, payload);
    return response.data;
  },

  /**
   * 📄 Obtener traslado por ID
   * GET /api/inventory/transfers/{id}
   */
  getById: async (id: number) => {
    const response = await inventoryTransferApi.fetchCustom(`/${id}`);
    return response.data;
  },

  /**
   * ✔ Aprobar traslado
   * PUT /api/inventory/transfers/{id}/approve
   */
  approve: async (id: number) => {
    const response = await inventoryTransferApi.modifyPathVariable(`${id}/approve`);
    return response.data;
  },

  /**
   * ✔ Confirmar traslado (mueve stock)
   * PUT /api/inventory/transfers/{id}/confirm
   */
  confirm: async (id: number) => {
    const response = await inventoryTransferApi.modifyPathVariable(`${id}/confirm`);
    return response.data;
  },

  /**
   * ❌ Rechazar traslado
   * PUT /api/inventory/transfers/{id}/reject
   */
  reject: async (id: number) => {
    const response = await inventoryTransferApi.modifyPathVariable(`${id}/reject`);
    return response.data;
  },

  /**
   * 🚫 Cancelar traslado
   * PUT /api/inventory/transfers/{id}/cancel
   */
  cancel: async (id: number) => {
    const response = await inventoryTransferApi.modifyPathVariable(`${id}/cancel`);
    return response.data;
  },

  /**
   * 🔄 Revertir traslado
   * PUT /api/inventory/transfers/{id}/reverse
   */
  reverse: async (id: number) => {
    const response = await inventoryTransferApi.modifyPathVariable(`${id}/reverse`);
    return response.data;
  },
};

export default InventoryTransferService;
